import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createGoodsspu, updateGoodsspu } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import Category from '@/view/bianlidianManage/category/category';
import UploadImage from '@/components/upload/image';
import CouponSelect from '@/components/couponSelect/couponSelect';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { removeImgUrlSuffix } from '@/utils/stringFun';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BianlidianGoodsSpuForm',
  components: {
    Category: Category,
    UploadImage: UploadImage,
    CouponSelect: CouponSelect
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  props: ['addSPUDialogFormData', 'hideItems'],
  data: function data() {
    return {
      path: process.env.VUE_APP_BASE_API,
      // eslint-disable-next-line vue/no-dupe-keys
      dialogData: {},
      categoryDialogVisible: false,
      categoryParentNo: '',
      addImgUrl: '',
      couponFormData: {
        dialogVisible: false,
        selection: [] // 回显，如果有数据，组件默认勾选

      },
      rules: {
        categoryNo: [{
          required: true,
          message: '请选择类目',
          trigger: 'blur'
        }],
        goodsName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        goodsUnit: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        goodsSpecification: [{
          required: true,
          message: '请输入规格',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('spu add created');
              _this2.dialogData = _this2.initSPUaddSPUDialogFormData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 添加图片链接
    onAddImgUrl: function onAddImgUrl() {
      if (this.addImgUrl.trim() != '') {
        this.dialogData.formData.goodsImg = removeImgUrlSuffix(this.addImgUrl.trim());
      }

      this.addImgUrl = '';
    },
    onDeleteImg: function onDeleteImg() {
      this.dialogData.formData.goodsImg = '';
    },
    initSPUaddSPUDialogFormData: function initSPUaddSPUDialogFormData() {
      var _this$addSPUDialogFor;

      var addSPUDialogFormData = {
        type: 'add',
        configTicketAble: [],
        formData: {
          categoryNo: '',
          categoryName: '',
          goodsName: '',
          goodsType: 2,
          // 商品类型 1=油品  2=非油品
          goodsOfficialPrice: '',
          goodsUnit: '',
          goodsSpecification: '',
          goodsDesc: '',
          goodsImg: '',
          goodsTicket: ''
        }
      };

      if (this.addSPUDialogFormData && this.addSPUDialogFormData.type && this.addSPUDialogFormData.type !== '') {
        addSPUDialogFormData.type = this.addSPUDialogFormData.type;
      }

      if (this.addSPUDialogFormData && this.addSPUDialogFormData.formData && JSON.stringify(this.addSPUDialogFormData.formData !== '{}')) {
        addSPUDialogFormData.formData = Object.assign(addSPUDialogFormData.formData, this.addSPUDialogFormData.formData);

        if (typeof addSPUDialogFormData.formData.goodsTicket === 'string') {
          addSPUDialogFormData.formData.goodsTicket = JSON.parse(addSPUDialogFormData.formData.goodsTicket || '[]');
        }
      }

      addSPUDialogFormData.configTicketAble = ((_this$addSPUDialogFor = this.addSPUDialogFormData) === null || _this$addSPUDialogFor === void 0 ? void 0 : _this$addSPUDialogFor.configTicketAble) || [];
      return addSPUDialogFormData;
    },
    enterDialog: function enterDialog() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, param;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;
                param = JSON.parse(JSON.stringify(that.dialogData.formData));
                param.goodsOfficialPrice = parseFloat(param.goodsOfficialPrice);
                param.goodsTicket = param.goodsTicket !== '' && param.goodsTicket.length > 0 ? JSON.stringify(param.goodsTicket) : '';

                if (that.dialogData.type === 'add') {
                  that.$refs['formData'].validate(function (valid) {
                    if (valid) {
                      createGoodsspu(param).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.handelSPUDialogClose();
                          that.handleSPUDialogCallback(res.data);
                        }
                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

                if (that.dialogData.type === 'update') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      updateGoodsspu(param).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.handelSPUDialogClose();
                          that.handleSPUDialogCallback(res.data);
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handelSPUDialogClose: function handelSPUDialogClose() {
      this.$parent.handelSPUDialogClose();
    },
    handleSPUDialogCallback: function handleSPUDialogCallback(res) {
      if (this.$parent.handleSPUDialogCallback) {
        this.$parent.handleSPUDialogCallback(res);
      }
    },
    onSelCategory: function onSelCategory() {
      var that = this;
      that.categoryDialogVisible = true;

      if (this.$refs.Category) {
        this.$refs.Category.resetForComponent();
      }
    },
    closeCategoryDialog: function closeCategoryDialog() {
      this.categoryDialogVisible = false;

      if (this.$refs.Category) {
        this.$refs.Category.resetForComponent();
      }
    },
    enterCategoryDialog: function enterCategoryDialog() {
      var that = this;
      var selCategory = that.$refs.Category.getSelectionForComponent();

      if (selCategory && selCategory.length > 0) {
        that.dialogData.formData.categoryNo = selCategory[0].id;
        that.dialogData.formData.categoryName = selCategory[0].label;
        that.categoryParentNo = selCategory[0].pid;
      } else {
        that.dialogData.formData.categoryNo = '';
        that.dialogData.formData.categoryName = '';
        that.categoryParentNo = '';
      }

      that.categoryDialogVisible = false;
    },
    // 上传成功
    uploadSuccess: function uploadSuccess(res) {
      // eslint-disable-next-line eqeqeq
      if (res.code != 0) {
        this.$message({
          type: 'warning',
          message: res.msg
        });
        return;
      }

      if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
        this.dialogData.formData.goodsImg = this.path + '/' + res.data.file.url;
      } else {
        this.dialogData.formData.goodsImg = res.data.file.url;
      }
    },
    // 添加优惠券
    onAddTicket: function onAddTicket() {
      this.couponFormData.dialogVisible = true;
    },
    // 删除优惠券
    onDelTicket: function onDelTicket(row) {
      var that = this;
      that.dialogData.formData.goodsTicket = that.dialogData.formData.goodsTicket.filter(function (item) {
        return item.ticketRuleNo != row.ticketRuleNo;
      });
    },
    // 选择优惠券-确定
    ticketSelDialogOk: function ticketSelDialogOk(res) {
      debugger;
      var that = this;
      that.couponFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          var isExit = false;
          that.dialogData.formData.goodsTicket.forEach(function (item2) {
            if (item2.ticketRuleNo == item.ticketRuleNo) {
              isExit = true;
            }
          });

          if (!isExit) {
            that.dialogData.formData.goodsTicket.push({
              ticketRuleNo: item.ticketRuleNo + '',
              'ticketName': item.ticketName,
              'num': 1
            });
          }
        });
      }
    },
    // 选择优惠券-关闭
    ticketDialogClose: function ticketDialogClose() {
      this.couponFormData.dialogVisible = false;
    }
  }
};